// extracted by mini-css-extract-plugin
export default {"search":"materials_search__lO76z","fieldList":"materials_fieldList__gnHqv","field":"materials_field__YC1io","count":"materials_count__fKszb","list":"materials_list__EYst+"};